import styled, { keyframes } from "styled-components";

const LoadingAnim = keyframes`
   0%   {background-position: 0    0,100% 0   ,100% 100%,0 100%}
   33%  {background-position: 0    0,100% 0   ,100% 100%,0 100%;width:45px;height: 45px}
   66%  {background-position: 100% 0,100% 100%,0    100%,0 0   ;width:45px;height: 45px}
   100% {background-position: 100% 0,100% 100%,0    100%,0 0   }
`

const Container = styled.div<{$busy: boolean}>`
	position: absolute;
	inset: 0;
	pointer-events: none;
	opacity: ${({$busy}) => $busy ? 1 : 0};
	display: flex;
	justify-content: center;
	align-items: center;
`

const Loader = styled.div`
	width: 30px;
    height: 30px;
	border-radius: 4px;
	
    --square:	no-repeat linear-gradient(${({theme}) => theme.colours.primary.normal} 0 0);

    background: var(--square),var(--square),var(--square),var(--square);
    background-size: 16px 16px;
	animation: ${LoadingAnim}  1.5s infinite cubic-bezier(0.3,1,0,1);
`


export const LoadingOverlay : React.FC<{busy: boolean}> = ({busy}) => {
	return (
		<Container $busy={busy} id="busy">
			<Loader/>
		</Container>
	)
}